import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://dunxthdkpjeguqepfjak.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR1bnh0aGRrcGplZ3VxZXBmamFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE2NjUwMjgsImV4cCI6MjA3NzI0MTAyOH0.gjbCfDE0lrEYt0ku0ROThZkCtK8MX2v9_yVKgFv-b4g';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn('[Supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY ausentes — usando fallback hardcoded. Configure .env para rotação.');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});